<template>
  <div class="exception">
    <div class="img">
      <img src="https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg" alt="404"/>
    </div>
    <div class="content">
      <h1>404</h1>
      <div class="desc">PAGE NOT FOUND</div>
      <div class="action">
        <p>We Couldn't Find This Page</p>
        <button class="file-upload-button btn" @click="handleToHome">HOMEPAGE</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleToHome () {
      this.$router.push("/")
    }
  }
}
</script>



<style lang="scss">
.exception {
  min-height: 500px;
  height: 80%;
  align-items: center;
  text-align: center;
  margin-top: 150px;
  .img {
    display: inline-block;
    padding-right: 52px;
    zoom: 1;
    img {
      height: 360px;
      max-width: 430px;
    }
  }
  .content {
    display: inline-block;
    flex: auto;
    h1 {
      color: #434e59;
      font-size: 72px;
      font-weight: 600;
      line-height: 72px;
      margin-bottom: 24px;
    }
    .desc {
      color: rgba(0, 0, 0, .45);
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 16px;
    }
  }
}
.file-upload-button{
  background: #0070ba;
  color: white;
  padding-left: 18px;
  padding-right: 18px;
  font-weight: bold;
  border-radius: 8px;
}

.mobile {
  .exception {
    margin-top: 30px;
    .img {
      padding-right: unset;

      img {
        height: 40%;
        max-width: 80%;
      }
    }
  }
}
</style>